// Dependencies
import React from 'react';
import { useSubmit } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

// Styles
import {
  ArrowBackLink,
  ContainerForm,
  ContainerOra,
  Infotext,
  LinkPolicy,
  OraLogo,
  PasswordButton,
  Title,
} from './styles';

import LeftArrow from '../../../assets/icons/arrow-left.svg';
import LogoOra from '../../../assets/logo.svg';

// Components
import { Typography } from '../../display/Typography';
import InputText from '../../inputs/InputText';

// Media

// Types
import { ResetPasswordFormType } from './types';

// Schema
import { ResetPasswordFormSchema } from './schema';

// Utils
import { createFormDataFromValues } from '../../../utils/forms';

// Media
import { useIsLandscapeTablet } from '../../../hooks/useMediaBreakPoints';

export default function ResetPasswordForm() {
  const { t } = useTranslation('auth');
  const isLandscapeTablet = useIsLandscapeTablet();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<ResetPasswordFormType>({
    mode: 'onTouched',
    reValidateMode: 'onBlur',
    defaultValues: {
      newPassword: '',
      repeatPassword: '',
    },
    resolver: yupResolver(ResetPasswordFormSchema) as any,
  });

  const submit = useSubmit();

  const onFormSubmit = (values: ResetPasswordFormType) => {
    const formData = createFormDataFromValues(values);

    submit(formData, {
      method: 'post',
      action: '/reset-password',
    });
  };

  return (
    <>
      <ContainerOra>
        <ArrowBackLink to={'/login'}>
          <img src={LeftArrow} alt={t('common:labels.goBack')} />
        </ArrowBackLink>
        <OraLogo src={LogoOra} alt={t('auth:login.roisLogo')} />
      </ContainerOra>
      <ContainerForm onSubmit={handleSubmit(onFormSubmit)}>
        <Title size="XL" variant="semiBold">
          {t('resetPassword.title')}
        </Title>
        <InputText
          {...register('newPassword')}
          label={t('resetPassword.newPassword')}
          labelSize={isLandscapeTablet ? 'XS' : 'S'}
          typeInput="password"
          type="password"
          placeholder={t('resetPassword.passwordPlaceholder')}
          error={errors.newPassword?.message}
        />
        <Infotext size="S">
          {t('resetPassword.passwordInstructions')}
        </Infotext>
        <InputText
          {...register('repeatPassword')}
          label={t('resetPassword.confirmPassword')}
          labelSize={isLandscapeTablet ? 'XS' : 'S'}
          typeInput="password"
          type="password"
          placeholder={t('resetPassword.passwordPlaceholder')}
          error={errors.repeatPassword?.message}
        />
        <PasswordButton
          text={t('resetPassword.saveAndLogin')}
          disabled={false}
        />
        <LinkPolicy to={'#'}>
          <Typography size={isLandscapeTablet ? 'XXXS' : 'XS'}>
            {t('login.acceptingTerms')} <b>{t('login.privacyPolicy')}</b>
          </Typography>
        </LinkPolicy>
      </ContainerForm>
    </>
  );
}
